/**
 * Arquivo de 2,2 MB vira ~3 MB em base64 dentro do JSON.
 * O Node aceita até 20 MB; o teto daqui deixa margem para arquivos desse porte
 * sem reduzir a imagem. Acima disso, imagem é reduzida e o restante é recusado.
 */
const LIMITE_JSON = 12 * 1024 * 1024;

function lerDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Não foi possível ler o arquivo.'));
        reader.readAsDataURL(file);
    });
}

function carregarImagem(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Não foi possível ler a imagem.'));
        img.src = src;
    });
}

function desenharJpeg(img, ladoMax, qualidade) {
    const maior = Math.max(img.width, img.height) || 1;
    const escala = Math.min(1, ladoMax / maior);
    const w = Math.max(1, Math.round(img.width * escala));
    const h = Math.max(1, Math.round(img.height * escala));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);
    return canvas.toDataURL('image/jpeg', qualidade);
}

function cabeNoLimite(dataUrl) {
    return String(dataUrl || '').length + 200 <= LIMITE_JSON;
}

async function reduzirImagem(file, original) {
    const img = await carregarImagem(original);
    let lado = 1920;
    let qualidade = 0.82;
    let ultimo = original;
    for (let i = 0; i < 10; i += 1) {
        ultimo = desenharJpeg(img, lado, qualidade);
        if (cabeNoLimite(ultimo)) {
            const nome = String(file.name || 'imagem').replace(/\.[^.]+$/, '') + '.jpg';
            return { base64: ultimo, nome };
        }
        if (qualidade > 0.45) qualidade -= 0.12;
        else lado = Math.round(lado * 0.7);
        if (lado < 480) break;
    }
    const err = new Error('A imagem continua grande demais depois da redução. Escolha um arquivo menor.');
    err.code = 'ARQUIVO_GRANDE';
    throw err;
}

export async function arquivoParaAnexo(file) {
    if (!file) return { base64: '', nome: '' };
    const tipo = String(file.type || '');
    const imagem = tipo.startsWith('image/') && tipo !== 'image/gif' && tipo !== 'image/svg+xml';
    const original = await lerDataUrl(file);
    if (cabeNoLimite(original)) {
        return { base64: original, nome: file.name };
    }
    if (imagem) return reduzirImagem(file, original);
    const err = new Error('O arquivo passa de 8 MB. Reduza o tamanho e tente novamente.');
    err.code = 'ARQUIVO_GRANDE';
    throw err;
}

export function mensagemErroAnexo(err) {
    const status = err?.response?.status;
    const semResposta = !err?.response && (err?.code === 'ERR_NETWORK' || err?.message === 'Network Error');
    if (status === 413 || err?.code === 'ARQUIVO_GRANDE' || semResposta) {
        return 'O servidor recusou o anexo por tamanho. Um arquivo de 2,2 MB ocupa cerca de 3 MB no envio. Peça para aumentar o limite do proxy da API (Nginx: client_max_body_size 8m).';
    }
    return err?.response?.data?.error || err?.response?.data?.message || 'Erro ao gravar anexo. Tente novamente.';
}
